const TOOL_OUTPUT_EXTENSION_MAP: Record<string, string> = {
  'pdf-to-word': 'docx',
  'word-to-pdf': 'pdf',
  'pdf-to-excel': 'xlsx',
  'excel-to-pdf': 'pdf',
  'pdf-to-ppt': 'pptx',
  'ppt-to-pdf': 'pdf',
  'pdf-to-jpg': 'jpg',
  'jpg-to-pdf': 'pdf',
  compress: 'pdf',
  'merge-pdf': 'pdf',
  'split-pdf': 'pdf',
  'extract-pdf-pages': 'pdf',
  'delete-pdf-pages': 'pdf',
  'rotate-pdf': 'pdf',
  'edit-pdf': 'pdf',
  'annotate-pdf': 'pdf',
  sign: 'pdf',
  'sign-pdf': 'pdf',
};

const normalizeExtension = (value?: string | null) =>
  value?.toLowerCase().replace(/^\./, '') || '';

const getFileExtension = (file?: File | null) =>
  normalizeExtension(file?.name?.split('.').pop());

export const resolveProcessPreviewExtension = ({
  extension,
  toolType,
  file,
  processedFile,
}: {
  extension?: string | null;
  toolType?: string | null;
  file?: File | null;
  processedFile?: File | null;
}) => {
  const normalizedExtension = normalizeExtension(extension);
  const fileExtension = getFileExtension(file);
  const processedFileExtension = getFileExtension(processedFile);
  const mappedToolExtension = toolType
    ? TOOL_OUTPUT_EXTENSION_MAP[toolType] || ''
    : '';

  if (normalizedExtension && normalizedExtension !== fileExtension) {
    return normalizedExtension;
  }

  if (processedFileExtension) {
    return processedFileExtension;
  }

  if (mappedToolExtension) {
    return mappedToolExtension;
  }

  return normalizedExtension || fileExtension;
};
